export default __webpack_public_path__ + "static/reed-3-9788cf23d243ed0f0b02d172eb4fb8ac.webp";